export const mainViewId = "mainView";
export const cardsById = "cardsById";

export const searchShipmentLoadingText = "Please, wait... Container is loading";
export const savedShipmentLoadingText = "Loading saved shipments, please wait";
